const account = {
  delete: "Mein Konto löschen",
  deleteUser: "Konto löschen",
  deleteWarning:
    "Möchten Sie Ihr Konto wirklich löschen? Nach der Löschung werden alle Ihre Daten sowie Ihr Abonnement dauerhaft gelöscht und können nicht wiederhergestellt werden.",
  deleteUserWarning:
    "Möchten Sie dieses Konto wirklich löschen? Nach der Löschung können alle Daten sowie das Abonnement nicht wiederhergestellt werden.",
  accountCreated:
    "Ihr Konto wurde erfolgreich erstellt. Eine Bestätigungs-E-Mail wurde an Sie gesendet (es kann bis zu einer Minute dauern, bis sie ankommt. Bitte überprüfen Sie auch Ihren Spam-Ordner).",
  accessMyAccount: "Zu meinem Konto",
  myAccount: "Mein Konto",
  yourAccountNotActive: "Ihr Konto ist noch nicht aktiviert.",
};

export default account;
